import {DocumentReference, FieldValue, Firestore, Timestamp, runTransaction, serverTimestamp} from 'firebase/firestore';
import {substituteServerTimestamp} from '#common/firebase/converters';
import {Entity, MetadataField, ServerTimestampSentinelValue} from '#common/models/Entity';

/**
 * Checks if a value is a Firebase type that should be preserved during sanitization.
 */
const isPreservedType = (value: unknown): boolean =>
  value instanceof Date || value instanceof Timestamp || value instanceof FieldValue;

export class FirestoreWritable<T extends Entity> {
  constructor(
    protected readonly firestore: Firestore,
    protected readonly currentUserId: string,
  ) {}

  protected createDocument(reference: DocumentReference<T>, entity: T): Promise<void> {
    const data = substituteServerTimestamp(
      {
        ...entity,
        [MetadataField]: {
          createdBy: this.currentUserId,
          createdTime: ServerTimestampSentinelValue,
          deleted: false,
          updatedBy: this.currentUserId,
          updatedTime: ServerTimestampSentinelValue,
        },
      },
      serverTimestamp,
      isPreservedType,
    );
    return runTransaction(this.firestore, async (transaction) => {
      const snapshot = await transaction.get(reference);
      if (snapshot.exists()) {
        throw new Error(`Document [${data.id}] already exists`);
      }
      transaction.set(reference, data);
    });
  }
}
